<template>
  <div class="a2p-callout" :class="type">
    <div class="a2p-callout-icon">
      <span v-if="type === 'warn'">⚠</span>
      <span v-else-if="type === 'danger'">!</span>
      <span v-else-if="type === 'success'">✓</span>
      <span v-else>i</span>
    </div>
    <div><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'A2PCallout',
  props: {
    type: {
      type: String,
      default: 'info',
      validator: (v) => ['info', 'warn', 'success', 'danger'].includes(v),
    },
  },
};
</script>
